<template>
  <div>
    <van-tabbar v-model="active" active-color="#FF5000" inactive-color="#333" :z-index="9" route :border="false" :safe-area-inset-bottom="false" class="kl-glass-tabbar" :style="{ '--kl-tab-count': tabbars.length }">
      <van-tabbar-item replace icon="apps-o" to="/stagingModule/index">工作台</van-tabbar-item>
      <van-tabbar-item icon="orders-o" to="/orderModule/index">订单</van-tabbar-item>
      <van-tabbar-item icon="paid" to="/accountModule/index">账户</van-tabbar-item>
      <van-tabbar-item icon="contact" to="/myModule/index">我的</van-tabbar-item>
      <!-- 选中项下面的浅灰胶囊，切 Tab 时滑到新位置 -->
      <div v-show="activeIndex > -1" class="kl-glass-tabbar__glider" :style="{ transform: `translateX(${activeIndex * 100}%)` }"></div>
    </van-tabbar>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const active = ref(0)
const tabbars = [
  {
    title: '工作台',
    url: '/stagingModule/index',
  },
  {
    title: '订单',
    url: '/orderModule/index',
  },
  {
    title: '账户',
    url: '/accountModule/index',
  },
  {
    title: '我的',
    url: '/myModule/index',
  },
]
// 高亮位置按当前路由算。原来 onMounted 里的 utilResetArr(copyTabbars, tabbars) 参数是反的，会把 tabbars 清空，copyTabbars 又没人用，已删
const activeIndex = computed(() => tabbars.findIndex((x) => route.path.startsWith(x.url)))
</script>

<style lang="scss">
// 悬浮毛玻璃胶囊底栏（10-22，参照 BOSS 直聘 / iOS 26 液态玻璃 TabBar，与用户端 H5 同款）
// Tab 首页底部留白统一用 --kl-tabbar-space = 栏底距 + 栏高 + 8px
:root {
  --kl-tabbar-space: calc(72px + env(safe-area-inset-bottom) * 0.3);
}
.van-tabbar.kl-glass-tabbar {
  left: 18px;
  right: 18px;
  bottom: calc(10px + env(safe-area-inset-bottom) * 0.3);
  width: auto;
  height: 54px;
  padding: 4px;
  box-sizing: border-box;
  border-radius: 27px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.6), 0 0 0 0.5px rgba(0, 0, 0, 0.06), 0 4px 20px rgba(0, 0, 0, 0.12);
  --van-tabbar-item-active-background: transparent;
  .van-tabbar-item {
    position: relative;
    z-index: 1;
    background: transparent;
  }
}
@supports ((-webkit-backdrop-filter: blur(1px)) or (backdrop-filter: blur(1px))) {
  .van-tabbar.kl-glass-tabbar {
    background: rgba(255, 255, 255, 0.72);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    backdrop-filter: blur(20px) saturate(180%);
  }
}
.kl-glass-tabbar__glider {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  width: calc((100% - 8px) / var(--kl-tab-count));
  border-radius: 23px;
  background: rgba(0, 0, 0, 0.06);
  transition: transform 0.35s cubic-bezier(0.3, 0.7, 0.2, 1);
}
</style>
